export function getIntDate() {
  const date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  if (month < 3) {
    year = year - 1
    month = month + 10
  } else {
    month = month - 2
  }
  month = month.toString()
  month = month[1] ? month : `0${month}`
  return year + '-' + month
}
